import * as braze from '@braze/web-sdk'
import { useEffect } from 'react'

import { useBoundStore } from '../store/store'

const useBrazePageView = () => {
  const username = useBoundStore(state => state.user.username)
  const email = useBoundStore(state => state.user.email)
  const phone = useBoundStore(state => state.user.phone)
  const pathname = window.location.pathname

  useEffect(() => {
    // Wait for Braze to be ready
    if (typeof braze === 'undefined' || !braze) {
      return
    }

    // Log page view event to Braze
    try {
      braze.logCustomEvent('page_view', {
        username,
        email,
        phone,
        pathname: pathname,
        url: window.location.href,
        title: document.title,
        timestamp: new Date().toISOString(),
      })
    } catch (error) {
      console.error('Failed to log Braze page view:', error)
    }
  }, [pathname])
}

export default useBrazePageView
